import { OfficeRateLimitsApi } from '../clients';

/**
 * One entry per organization the identity belongs to; empty when it belongs to
 * none.
 *
 * @param {string} identityId - The identity's auth-service user id
 * @returns {Promise<import('../types').IMemberRateLimits[]>}
 */
export const getMemberRateLimits = async (identityId) => {
  const { items } = await OfficeRateLimitsApi.getMemberRateLimits(identityId);
  return items;
};
